import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from '../core/services/api.service';
import { ConfigService } from '../core/services/config.service';

interface CertificateMailSentResponse {
  IsSent?: boolean;
  isSent?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  constructor(private apiService: ApiService, private configService: ConfigService) {
  }

  public certificateMailSent(id: number): Observable<boolean> {
    const apiEndpoint = this.configService.obligationPaymentCertificateMailSentUrl
      .replace('{id}', id.toString());

    return this.apiService.find<CertificateMailSentResponse>(apiEndpoint).pipe(
      map((response: CertificateMailSentResponse) => !!(response && (response.IsSent ?? response.isSent)))
    );
  }

   getObligations(paymentId: number): Observable<any> {
    const url = this.configService.obligationPaymentObligationsUrl
      .replace('{id}', paymentId.toString());
    return this.apiService.find(url);
  }
}
